
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/build-vs-buy",
      function () {
        return require("private-next-pages/build-vs-buy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/build-vs-buy"])
      });
    }
  